import { store } from './store.js';

export var shared = {
    methods: {
        getLabel: function (key) {
            var label = store.getLabel(key);
            return label;
        }
    }
}